export const QandAitems = [
    {
        id: 1,
        question: "Pot veni la sediul Floris pentru a plati comanda in numerar?",
        answer: "Poti comanda si plati exclusiv online, folosind una dintre modalitatile de plata disponibile in site. Mai multe detalii despre plati gasesti "
    },
    {
        id: 2,
        question: "Puteti livra buchete si in strainatate?",
        answer: [
            {
                row1: "Da, livram oriunde in lume, in 24 de ore. Gasesti selectia de produse disponibile in sectiunea - ",
                row2: "Poti conta pe noi pentru livrare flori in strainatate. Daca ai o comanda de flori in afara Romaniei, o putem procesa noi. Comanda flori cu livrare internationala si livrare rapida, si in 24-48 de ore livram flori in toata lumea. Selectia noastra cuprinde buchete de flori si aranjamente cu livrare internationala."
            }
        ]
    },
    {
        id: 3,
        question: "Puteti livra si in comunele/satele care nu se afla in lista localitatilor afisate pe site?",
        answer: "Putem livra buchete oriunde in tara, prin intermediul retelei noastre de ateliere florale. Transportul este gratuit in orasele in care avem ateliere (peste 100). In localitatile din afara acestei arii, livram contra unui cost de transport calculat automat, in momentul in care selectezi localitatea de livrare. Daca localitatea in care doresti sa faci livrarea nu este acoperita de niciunul dintre atelierele noastre, asiguram serviciu de livrare prin curier rapid. Buchetele de flori sunt livrate in ambajal special, cu protectie si rezerva de apa. Astfel, poti comanda buchete de flori cu livrare oriunde in tara. Selectia de buchete de flori livrate in cutie este disponibila pe pagina dedicata: "
    },
    {
        id: 4,
        question: "In cat timp de la plasarea comenzii ajunge aceasta la destinatie?",
        answer: [
            {
                row1: "Termenul mediu de livrare in Bucuresti si alte peste 140 de orase este intre 2 si 4 ore de la momentul confirmarii in sistem a platii.",
                row2: "Asadar, poti comanda buchete de flori cu livrare in aceeasi zi. Poti plasa chiar o comanda de flori online in provincie. Asiguram livrare rapida buchete de flori oriunde in tara, oriunde ai fi. Indiferent de ora, poti plasa o comanda de flori cu livrare rapida in tara.",
            }
        ]
    },
]